import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Bookmark } from '../../models/bookmark';

@Injectable({
  providedIn: 'root'
})
export class BookmarksService {

  constructor(private http: HttpClient) {
  }

  private base = environment.bookmarksApiConfig.baseUrl;

  saveBookmark(bookmark: Bookmark): Observable<{ rowKey: string }> {
    return this.http.post<{ rowKey: string }>(
      this.base,
      bookmark
    );
  }

  updateBookmark(bookmark: Bookmark): Observable<{ rowKey: string }> {
    return this.http.put<{ rowKey: string }>(
      `${this.base}`,
      bookmark
    );
  }

  fetchBookmarks(userId: string): Observable<Bookmark[]> {
    const url = `${this.base}/${userId}`;
    return this.http.get<Bookmark[]>(url);
  }
}
